import { CustomerPortalRequestMessageAttachment } from "../api/models/unified";
import { ImageViewerItem } from "../components/attachments/ImageViewer";
import { IconName } from "../components/icon/src/helper";

const extensionReg = /(?:\.([^.]+))?$/;

const getExtension = (fileName: string) => {
  const result = extensionReg.exec(fileName);
  return result?.[1]?.toLowerCase();
};

export const isImage = (attachment: ImageViewerItem): boolean => {
  const extension = getExtension(attachment.publicUrl);
  return extension === "png" || extension === "jpg" || extension === "jpeg";
};

// export const handleAttachmentThumbnailIconName = (
//   attachment: CustomerPortalRequestMessageAttachment,
// ): IconName => {
//   const extension = getExtension(attachment.publicUrl);
//   if (extension === "png" || extension === "jpg" || extension === "jpeg") {
//     return "image";
//   }

//   if (extension === "mp3" || extension === "wav") {
//     return "sound";
//   }

//   if (extension === "pdf") {
//     return "pdf";
//   }

//   if (
//     extension === "mp4" ||
//     extension === "mkv" ||
//     extension === "wmv" ||
//     extension === "mpeg"
//   ) {
//     return "video";
//   }

//   if (extension === "xls" || extension === "xlsx") {
//     return "excel";
//   }

//   if (extension === "doc" || extension === "docx") {
//     return "word";
//   }

//   return "file";
// };
